var fadeOverlay = (function () {
	const theOverlay = document.querySelector('#fadeOverlay');

	//@Desc: NormalCase: ShowFade Overlay->Go to href; Special Case for e.g. ShowFadeOverlay, submitForm on Same Page...
	function showFadeOverlay(aimAnchor, callback, opacity) {
		// Show FadeOverlay
		theOverlay.style.display = 'block';

		// Async Show Fade Overlay
		setTimeout(()=> {
			anime({
				targets: theOverlay,
				duration: 300,
				opacity: 1,
				easing: 'easeInOutCirc',
				complete: () => {
					if (typeof aimAnchor === 'string')
						window.location.href = aimAnchor;
					else if (typeof aimAnchor === 'boolean')
						callback();

				}
			})
		},0);
	}

	function hideFadeOverlay() {
		anime({
			targets: theOverlay,
			duration: 300,
			opacity: 0,
			easing: 'easeInOutCirc',
			complete: () => {
				theOverlay.style.display = 'none';
			}
		});
	}

	//Click Elements
	function setFadeLinkClickEvents() {
		Array.from(document.querySelectorAll('a.fadeLink')).forEach(currentLink => {
			currentLink.addEventListener('click', e => {
				e.preventDefault();
				showFadeOverlay(e.currentTarget.href)
			});
		});
	}


	//API
	return {
		show: showFadeOverlay,
		hide: hideFadeOverlay,
		setup: setFadeLinkClickEvents
	}
})();